import React from 'react';
import { Grid, Typography } from '@mui/material';
import { TrainingVideoLinks } from '../../../../../types/api';
import { Box } from '@mui/system';
import TrainingVideo from './TrainingVideo';

interface TrainingVideoListProps {
  videos: TrainingVideoLinks[];
  search: string;
}
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
const TrainingVideoList: React.FC<TrainingVideoListProps> = ({
  videos,
  search,
}) => {
  if (videos.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          py: 2,
        }}
      >
        <Box
          sx={{
            background: '#f0f3f8',
            borderRadius: '100px',
            width: '80px',
            height: '80px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <PlayArrowOutlinedIcon
            fontSize="large"
            style={{
              color: '#f5f6f8',
              background: '#d3d7e1',
              borderRadius: '8px',
            }}
          />
        </Box>
        <Typography
          variant="body1"
          color="text.secondary"
          align="center"
          py={2}
          pb={4}
        >
          There are no results for &quot;{search}&quot;. Please check spelling
          or try another search term.
        </Typography>
      </Box>
    );
  }

  return (
    <Box py={2}>
      <Grid container columnSpacing={1} rowSpacing={4} alignItems="stretch">
        {videos.map((video, index) => (
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} key={index}>
            <TrainingVideo video={video} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TrainingVideoList;
